import {Box, Button, Typography} from '@mui/material';
import {useEffect} from 'react';
import {useNavigate} from 'react-router';
import useGetUser from '../../../hook/useGetUser';
import {firebaseAuth} from '../../../setup/firebase';

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const {refetch} = useGetUser(firebaseAuth);

  useEffect(() => {
    if (!firebaseAuth.currentUser) return;

    const refreshUserData = async () => {
      // Refresh the Firebase token to get updated claims
      await firebaseAuth.currentUser!.getIdToken(true);

      // Refetch user data to get updated subscription information
      await refetch();
    };

    refreshUserData();
  }, [refetch]);

  return (
    <Box sx={{p: 3, textAlign: 'center'}}>
      <Typography variant="h4" gutterBottom>
        Subscription Successful!
      </Typography>
      <Typography variant="body1" gutterBottom>
        Thank you for subscribing to our service. Your subscription has been activated.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate('/subscription')} sx={{mt: 2}}>
        Return to Subscription Page
      </Button>
    </Box>
  );
}
